import { FormControl } from '@angular/forms';
import { MarkGroupFormGroup } from './markscheme-markgroup';
import { WorkedSolutionFormCtrl } from './solution-path';

export enum MarkschemeEditorItemEnum {
  MarkGroup = 'markgroup',
  WorkedSolution = 'worked_solution',
}

export const MARKSCHEME_ITEM_TYPES = [MarkschemeEditorItemEnum.MarkGroup, MarkschemeEditorItemEnum.WorkedSolution];

export const MARKSCHEME_ITEM_TYPE_TO_COLOR: Record<MarkschemeEditorItemEnum, string> = {
  [MarkschemeEditorItemEnum.MarkGroup]: 'green',
  [MarkschemeEditorItemEnum.WorkedSolution]: 'teal',
};

export const MARKSCHEME_ITEM_TYPE_TO_SHORT_LABEL: Record<MarkschemeEditorItemEnum, string> = {
  [MarkschemeEditorItemEnum.MarkGroup]: 'MG',
  [MarkschemeEditorItemEnum.WorkedSolution]: 'WS',
};

export const MARKSCHEME_ITEM_TYPE_TO_LONG_LABEL: Record<MarkschemeEditorItemEnum, string> = {
  [MarkschemeEditorItemEnum.MarkGroup]: 'Mark Group',
  [MarkschemeEditorItemEnum.WorkedSolution]: 'Worked Solution',
};

export interface ActiveMarkschemeMarkGroupEditorItem {
  ctrl: MarkGroupFormGroup;
  type: MarkschemeEditorItemEnum.MarkGroup;
  solutionPathsCountFC: FormControl<string>;
}

export interface ActiveMarkschemeWorkedSolutionEditorItem {
  ctrl: WorkedSolutionFormCtrl;
  type: MarkschemeEditorItemEnum.WorkedSolution;
}

export type ActiveMarkschemeEditorItem = ActiveMarkschemeMarkGroupEditorItem | ActiveMarkschemeWorkedSolutionEditorItem;

export type ActiveMarkschemeEditorSubItemCoordinates =
  | {
      criterion: number;
    }
  | {
      worked_solution: number;
    };

export type ActiveMarkschemeEditorItemCoordinates =
  | {
      'markscheme.all_mark_groups': number;
    }
  | {
      'markscheme.solution_paths': number;
    };

export function isActiveMarkschemeEditorItem(item: string | undefined): item is ActiveMarkschemeEditorItem['type'] {
  if (!item) {
    return false;
  }

  return item === MarkschemeEditorItemEnum.MarkGroup || item === MarkschemeEditorItemEnum.WorkedSolution;
}
